<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mm-0 mb-4">FAQS</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
		</div><!--row-->
		<div class="row">
			<div class="col-12 col-xl-7">
				<div class="row justify-content-between align-items-center mb-2">
					<div class="col-12 col-lg-3">
						<router-link :to="{ name : 'admin.faq.create'}" tag="a" class="button m-0">
							<img class="mr-1" src="../../../assets/images/icons/solid/plus_white.svg" width="12" />
							New FAQ
						</router-link>
					</div><!--col-->
					
				</div><!--row-->
				<div class="table-responsive">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th>Position</th>
								<th class="">Name</th>
								<th class="text-center">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in faqs" >
								<td>{{ item.order }}</td>
								<td><router-link :to="{ name: 'admin.faq.edit', params : { id : item.id } }" tag="a" class="bold">{{ item.title }}</router-link></td>
								<td class="text-center">
									
				      				<div class="trigger-hidden-content ml-1 d-inline-block">
										<span class=" button">
											<img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
										</span>
										<div class="hidden-content hc-right-bottom">
											<div>
												<ul class="list-unstyled text-left">
													<li class="pb-2 pt-2 d-flex align-items-center  cursor-pointer" @click="showDelete(item)">
														<img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
														<span> Delete</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				

				<b-modal v-model="show_delete" title="Delete FAQ" @ok="deleteFAQ" cancel-title="No" ok-title="Yes">
			    	<div v-if="faq_to_delete != null">
						<p class="mb-2">
							Are you sure you want to delete the FAQ {{ faq_to_delete.title }}?
						</p>
					</div>
				</b-modal>

			</div><!--col-->
			
		</div><!--row-->
	</div><!--container-->
</template>

<script>
	export default {
		data : function(){
			return {

				faqs : [],
				faq_to_delete : null,
				show_delete : false
			}
		},

		created : function(){
			this.getFAQS();
		},

		methods : {

			getFAQS : function() {

				var params = {
					filters : {
						page : this.current_page
					}
				}
				
				this.$store.dispatch('getFAQS', params).then((res) => {
					this.faqs = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},

			showDelete : function(faq){
				this.faq_to_delete = faq;
				this.show_delete = true;
			},
			deleteFAQ : function(){
				if(this.faq_to_delete){
					var params = {
						id : this.faq_to_delete.id
					}

					this.$store.dispatch('deleteFAQ', params).then((res) => {
						console.log(res);
						this.show_delete = false;

						this.getFAQS();
					}).catch((error) => {
						console.log(error);
					});
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/faqs/AdminFAQListComponent.vue